import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchActionCategories } from 'Redux/Admin/ProjectManager/ActionCategories/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { IActionCategory } from 'Redux/Admin/ProjectManager/ActionCategories/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const columns: TableColumnsType<IActionCategory> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/project-manager/action-categories/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'Project Plan',
    dataIndex: 'project_plan',
    key: 'project_plan',
    width: 280,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 280,
  },
  {
    title: 'Weight',
    dataIndex: 'weight',
    key: 'weight',
    width: 180,
  },
  {
    title: 'Category Progress',
    dataIndex: 'category_progress',
    key: 'category_progress',
    width: 180,
  },
  {
    title: 'Plan Progress',
    dataIndex: 'plan_progress',
    key: 'plan_progress',
    width: 180,
  },
];

const ActionCategories = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const projectPlan = params.get('project_plan');
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchActionCategories);

  useEffect(() => {
    dispatch(fetchActionCategories({ project_plan: projectPlan, offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [projectPlan, pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    {
      type: 'project-plan-select',
      paramName: 'project_plan',
      placeholder: 'Select project plan...',
      label: 'Project Plan'
    },
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<IActionCategory>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/project-manager/action-categories/new`}
      filters={filterConfigs}
    />
  );
}

export default ActionCategories;
